<template>
    <ul class="mb-0 list-none border-grey-200 border rounded p-5">
        <li>
            <h5>Username</h5>
            <p>{{ username }}</p>
        </li>
        <li>
            <h5>Password</h5>

            <toggle-password-display v-if="password" :password="password" />
            <template v-else>
                <p>Not set</p>
            </template>
        </li>
        <li>
            <h5>Port</h5>
            <p>{{ port }}</p>
        </li>
    </ul>
</template>
<script>
import togglePasswordDisplay from '../../utilities/PasswordToggle';
export default {

    components: {
        'toggle-password-display': togglePasswordDisplay
    },

    props: {
        password: {
            type: String,
            default: ''
        },
        username: {
            type: String,
            default: 'root'
        },
        port: {
            type: Number,
            default: 2929
        }
    },
}
</script>
